import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { App } from './App';
import { store } from './store';
import { ThemeProvider } from './theme/ThemeContext';
import { LanguageProvider } from './i18n/LanguageContext';
import './i18n'; // initialize the i18next singleton before first render
import { initSentry } from './observability/sentry';
import { posthog } from './observability/posthog';
import { GOOGLE_CLIENT_ID } from './auth/googleClientId';
import './styles/global.css';

// Order matters: Sentry first so it can catch errors from posthog init or
// React's render. Both are no-ops when their env vars are unset.
initSentry();
posthog.init();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <LanguageProvider>
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </GoogleOAuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);
